<template>
    <div class="scroll-horizontal">
        <table class="fundo-tabela" v-if="dados.tarefas.length > 0">
            <thead class="titulo">
                <tr class="text-left">
                    <th :colspan="dados.tarefas.length+1" class="titulo-tabela">EM EXECUÇÃO</th>
                </tr>
                <tr class="white--text">
                    <th class="fundo-primeira-coluna"></th>
                    <th
                        v-for="(macroprocesso, indexM) in dados.macroprocessos"
                        :colspan="macroprocesso.tarefas.length"
                        :key="indexM+'_macro_processo'"
                        :class="getBordaMacroProcesso(indexM)"
                        :style="'background-color: '+getCorMacroProcesso(macroprocesso.tarefas.length, indexM)"
                    >
                        {{ macroprocesso.macro_processo }}
                        <span class="d-block cursor-pointer" @click="detalharTarefas($event,null,null,macroprocesso.ctrl_macro_processo_id)">
                            {{macroprocesso.aging_total}}
                        </span>
                    </th>
                </tr>
                <tr>
                    <th class="fundo-primeira-coluna">IDADE (DIAS)</th>
                    <th
                        v-for="(tarefa, index) in dados.tarefas"
                        :key="'tarefa_'+index"
                        :style="'color: '+coresTarefas[index]"
                        :class="getBordaTarefa(index)+'vertical-text'"
                    >
                        <v-tooltip bottom color="black">
                            <template v-slot:activator="{ on, attrs }">
                                <h5 v-bind="attrs" v-on="on" class="font-size-12 cursor-pointer">
                                    <strong>{{ tarefa.tarefa }}</strong></h5>
                            </template>
                            <span>{{ tarefa.tarefa }}</span>
                        </v-tooltip>
                    </th>
                </tr>
            </thead>
            <tbody class="dados-aging">
                <tr>
                    <td class="fundo-primeira-coluna borda-primeirac">0</td>
                    <td v-for="(tarefa, index) in dados.tarefas"
                        :key="'index0_'+index"
                        :class="getBordarAging(index)+getBgAging(tarefa, 0)"
                    ><span class="cursor-pointer" @click="detalharTarefas($event,tarefa.ctrl_tarefa_id,'0')">{{ tarefa.aging.aging_0 }}</span></td>
                </tr>
                <tr>
                    <td class="fundo-primeira-coluna borda-primeirac">1</td>
                    <td v-for="(tarefa, index) in dados.tarefas"
                        :key="'index1_'+index"
                        :class="getBordarAging(index)+getBgAging(tarefa, 1)"
                    ><span class="cursor-pointer" @click="detalharTarefas($event,tarefa.ctrl_tarefa_id,'1')">{{ tarefa.aging.aging_1 }}</span></td>
                </tr>
                <tr>
                    <td class="fundo-primeira-coluna borda-primeirac">2</td>
                    <td v-for="(tarefa, index) in dados.tarefas"
                        :key="'index2_'+index"
                        :class="getBordarAging(index)+getBgAging(tarefa, 2)"
                    ><span class="cursor-pointer" @click="detalharTarefas($event,tarefa.ctrl_tarefa_id,'2')">{{ tarefa.aging.aging_2 }}</span></td>
                </tr>
                <tr>
                    <td class="fundo-primeira-coluna borda-primeirac">3</td>
                    <td v-for="(tarefa, index) in dados.tarefas"
                        :key="'index3_'+index"
                        :class="getBordarAging(index)+getBgAging(tarefa, 3)"
                    ><span class="cursor-pointer" @click="detalharTarefas($event,tarefa.ctrl_tarefa_id,'3')">{{ tarefa.aging.aging_3 }}</span></td>
                </tr>
                <tr>
                    <td class="fundo-primeira-coluna borda-primeirac">4</td>
                    <td v-for="(tarefa, index) in dados.tarefas"
                        :key="'index4_'+index"
                        :class="getBordarAging(index)+getBgAging(tarefa, 4)"
                    ><span class="cursor-pointer" @click="detalharTarefas($event,tarefa.ctrl_tarefa_id,'4')">{{ tarefa.aging.aging_4 }}</span></td>
                </tr>
                <tr>
                    <td class="fundo-primeira-coluna borda-primeirac">5</td>
                    <td v-for="(tarefa, index) in dados.tarefas"
                        :key="'index5_'+index"
                        :class="getBordarAging(index)+getBgAging(tarefa, 5)"
                    ><span class="cursor-pointer" @click="detalharTarefas($event,tarefa.ctrl_tarefa_id,'5')">{{ tarefa.aging.aging_5 }}</span></td>
                </tr>
                <tr>
                    <td class="fundo-primeira-coluna borda-primeirac">6</td>
                    <td v-for="(tarefa, index) in dados.tarefas"
                        :key="'index6_'+index"
                        :class="getBordarAging(index)+getBgAging(tarefa, 6)"
                    ><span class="cursor-pointer" @click="detalharTarefas($event,tarefa.ctrl_tarefa_id,'6')">{{ tarefa.aging.aging_6 }}</span></td>
                </tr>
                <tr>
                    <td class="fundo-primeira-coluna borda-primeirac">7</td>
                    <td v-for="(tarefa, index) in dados.tarefas"
                        :key="'index7_'+index"
                        :class="getBordarAging(index)+getBgAging(tarefa, 7)"
                    ><span class="cursor-pointer" @click="detalharTarefas($event,tarefa.ctrl_tarefa_id,'7')">{{ tarefa.aging.aging_7 }}</span></td>
                </tr>
                <tr>
                    <td class="fundo-primeira-coluna borda-primeirac">8 a 10</td>
                    <td v-for="(tarefa, index) in dados.tarefas"
                        :key="'index8_10_'+index"
                        :class="getBordarAging(index)+getBgAging(tarefa, 10)"
                    ><span class="cursor-pointer" @click="detalharTarefas($event,tarefa.ctrl_tarefa_id,'8_10')">{{ tarefa.aging.aging_8_10 }}</span></td>
                </tr>
                <tr>
                    <td class="fundo-primeira-coluna borda-primeirac">11 a 15</td>
                    <td v-for="(tarefa, index) in dados.tarefas"
                        :key="'index11_15_'+index"
                        :class="getBordarAging(index)+getBgAging(tarefa, 15)"
                    ><span class="cursor-pointer" @click="detalharTarefas($event,tarefa.ctrl_tarefa_id,'11_15')">{{ tarefa.aging.aging_11_15 }}</span></td>
                </tr>
                <tr>
                    <td class="fundo-primeira-coluna borda-primeirac">16 a 30</td>
                    <td v-for="(tarefa, index) in dados.tarefas"
                        :key="'index16_30_'+index"
                        :class="getBordarAging(index)+getBgAging(tarefa, 30)"
                    ><span class="cursor-pointer" @click="detalharTarefas($event,tarefa.ctrl_tarefa_id,'16_30')">{{ tarefa.aging.aging_16_30 }}</span></td>
                </tr>
                <tr>
                    <td class="fundo-primeira-coluna borda-primeirac">31 a 60</td>
                    <td v-for="(tarefa, index) in dados.tarefas"
                        :key="'index31_60_'+index"
                        :class="getBordarAging(index)+getBgAging(tarefa, 60)"
                    ><span class="cursor-pointer" @click="detalharTarefas($event,tarefa.ctrl_tarefa_id,'31_60')">{{ tarefa.aging.aging_31_60 }}</span></td>
                </tr>
                <tr>
                    <td class="fundo-primeira-coluna borda-primeirac">> 60</td>
                    <td v-for="(tarefa, index) in dados.tarefas"
                        :key="'indexmaior_60_'+index"
                        :class="getBordarAging(index)+getBgAging(tarefa, 61)"
                    ><span class="cursor-pointer" @click="detalharTarefas($event,tarefa.ctrl_tarefa_id,'maior_60')">{{ tarefa.aging.aging_maior_60 }}</span></td>
                </tr>
                <tr>
                    <td class="fundo-primeira-coluna borda-primeirac"><b>Total Geral</b></td>
                    <td v-for="(tarefa, index) in dados.tarefas"
                        :key="'index_total_'+index"
                        :class="getBordarAging(index)"
                    ><span class="cursor-pointer font-weight-bold" @click="detalharTarefas($event,tarefa.ctrl_tarefa_id,null)">{{ tarefa.aging.aging_total }}</span></td>
                </tr>
            </tbody>
        </table>
        <SGPAlertaComponent v-else>Dados não encontrados</SGPAlertaComponent>
    </div>

</template>
  
  <script>
  export default {
    name: "TabelaBacklogTarefaExecucaoComponent",
    props: {
      dados: {
        type: Object,
        required: true
      }
    },
  
    mounted() {
        document.documentElement.style.overflowX = 'scroll';
    },

    beforeDestroy() {
        document.documentElement.style.overflowX = '';
    },
    
    data() {
      return {
        cores: ['#83170F','#DA291C','#B84D01','#FB9C2D','#00818F'],
        coresTarefas: [],
        classBordaDestaque: ' borda-macroprocesso '
      }
    },
  
    methods: {
        getBgAging (tarefa, aging) {
            if (aging > tarefa.prazo_ctrl_tarefa) {
                return ' bg-vencido ';
            }
            return '';
        },
        getBordaMacroProcesso (indexM) {
            if(indexM + 1 != this.dados.macroprocessos.length){ 
                return this.classBordaDestaque;
            }
            return '';
        },

        getBordarAging (index) {
            let nextIndex = index + 1;
            if(this.coresTarefas[index] != this.coresTarefas[index+1]) {
                if (this.dados.tarefas.length != nextIndex) {
                    return this.classBordaDestaque;
                }
            }    
            return '';
        },

        getBordaTarefa (index) {
            let nextIndex = index+1;
            if (typeof this.coresTarefas[nextIndex] != 'undefined' && this.coresTarefas[nextIndex] != this.coresTarefas[index]) {
                if (this.dados.tarefas.length != nextIndex) {
                    return this.classBordaDestaque;
                }    
            }
            return '';
        },
        detalharTarefas (event,ctrlTarefa,aging,ctrlMacroProcessoId=null) {
            const ctrlFamiliaId=null;
            const interrupcoes = false;
            this.$emit('detalharTarefasEmit', {
                event,
                ctrlMacroProcessoId,
                ctrlTarefa,
                aging,
                ctrlFamiliaId,
                interrupcoes
            });
        },
        setCorTarefas(qtdTarefas, cor) {
            let posInicial = this.coresTarefas.length;
            let posFinal = posInicial + qtdTarefas;
            for(let j = posInicial ; j < posFinal; ++j) {
                this.coresTarefas[j] = cor;
            }
        },

        getCorMacroProcesso(qtdTarefas, indice) {
            let corSelecionada = this.cores[(indice % 5)];
            this.setCorTarefas(qtdTarefas, corSelecionada);
            return corSelecionada;
        },  
    },
    computed: {
      total() {
        return (
          this.qtdDefinirSolucao +
          this.qtdConstruirAcesso +
          this.qtdAprovisionarServico +
          this.qtdPrepararAtivacao +
          this.qtd_ativar_servico
        );
      },
    },
  };
  </script>